// Role definitions and permissions for Satellite Talent Dashboard
export const ROLES = {
  ADMIN: {
    name: 'admin',
    displayName: 'Administrator',
    permissions: [
      'view_all_nps',
      'view_individual_client_nps',
      'manage_users',
      'view_audit_logs',
      'export_all_data',
      'system_configuration',
      'view_candidates',
      'view_analytics',
      'manage_clients',
      'manage_client_access'
    ]
  },
  TALENT_PARTNER: {
    name: 'talent-partner',
    displayName: 'Talent Partner',
    permissions: [
      'view_candidates',
      'view_aggregated_nps',
      'view_analytics',
      'export_filtered_data',
      'manage_candidates',
      'view_pipeline'
    ]
  },
  CLIENT: {
    name: 'client',
    displayName: 'Client',
    permissions: [
      'view_own_pipeline',
      'view_own_metrics',
      'view_own_nps',
      'view_own_roles'
    ]
  }
};

// Permission definitions
export const PERMISSIONS = {
  // NPS Data Access
  VIEW_ALL_NPS: 'view_all_nps',
  VIEW_INDIVIDUAL_CLIENT_NPS: 'view_individual_client_nps',
  VIEW_AGGREGATED_NPS: 'view_aggregated_nps',
  
  // User Management
  MANAGE_USERS: 'manage_users',
  VIEW_AUDIT_LOGS: 'view_audit_logs',
  
  // Data Export
  EXPORT_ALL_DATA: 'export_all_data',
  EXPORT_FILTERED_DATA: 'export_filtered_data',
  
  // System
  SYSTEM_CONFIGURATION: 'system_configuration',
  
  // Core Features
  VIEW_CANDIDATES: 'view_candidates',
  MANAGE_CANDIDATES: 'manage_candidates',
  VIEW_ANALYTICS: 'view_analytics',
  VIEW_PIPELINE: 'view_pipeline',
  MANAGE_CLIENTS: 'manage_clients',
  
  // Client Portal
  VIEW_OWN_PIPELINE: 'view_own_pipeline',
  VIEW_OWN_METRICS: 'view_own_metrics',
  VIEW_OWN_NPS: 'view_own_nps',
  VIEW_OWN_ROLES: 'view_own_roles',
  MANAGE_CLIENT_ACCESS: 'manage_client_access'
};

// Default role for new users
export const DEFAULT_ROLE = ROLES.TALENT_PARTNER.name;

// Helper function to get role by name
export const getRoleByName = (roleName) => {
  return Object.values(ROLES).find(role => role.name === roleName) || ROLES.TALENT_PARTNER;
};

// Helper function to check if a role is client role
export const isClientRole = (roleName) => {
  return roleName === ROLES.CLIENT.name;
};

// Helper function to get all role names
export const getAllRoleNames = () => {
  return Object.values(ROLES).map(role => role.name);
};
